import React from 'react';

const Select = (props) => {
    const {
        name,
        value,
        onChange,
        options         = [],
        placeholder     = null,
        required        = false,
        disabled        = false,
        error           = null
    } = props;

    return (
        <select
            id={name}
            name={name}
            value={value}
            className={!error ? "form-control shadow-none" : "form-control shadow-none is-invalid"}
            required={required}
            disabled={disabled}
            onChange={(event) => onChange(event.target.value)}
        >
            {!!placeholder && (
                <option value="">{ placeholder }</option>
            )}
            {!!options && options.length && options.map((item, index) => (
                <option value={item.value} key={index}>{ item.label }</option>
            ))}
        </select>
    );
}

export default Select;
